import { useEffect } from 'react';
import { useSiteData } from '@/context/SiteDataContext';

// Applies dynamic theme (colors + fonts) from settings to :root CSS variables
export default function ThemeApplier() {
  const { settings } = useSiteData();
  useEffect(() => {
    if (!settings) return;
    const root = document.documentElement;
    if (settings.primary_color) {
      root.style.setProperty('--royal', settings.primary_color);
      root.style.setProperty('--royal-light', shade(settings.primary_color, 30));
      root.style.setProperty('--royal-dark', settings.primary_dark || shade(settings.primary_color, -30));
    }
    if (settings.accent_color) {
      root.style.setProperty('--gold', settings.accent_color);
      root.style.setProperty('--gold-light', shade(settings.accent_color, 20));
      root.style.setProperty('--gold-dark', shade(settings.accent_color, -20));
    }
    if (settings.heading_font) {
      root.style.setProperty('--font-heading', `"${settings.heading_font}", serif`);
      ensureGoogleFont(settings.heading_font);
    }
    if (settings.body_font) {
      root.style.setProperty('--font-body', `"${settings.body_font}", sans-serif`);
      ensureGoogleFont(settings.body_font);
      document.body.style.fontFamily = `"${settings.body_font}", sans-serif`;
    }
  }, [settings]);
  return null;
}

function shade(hex, percent) {
  const h = hex.replace('#', '');
  const r = parseInt(h.slice(0, 2), 16), g = parseInt(h.slice(2, 4), 16), b = parseInt(h.slice(4, 6), 16);
  const adj = (c) => Math.max(0, Math.min(255, Math.round(c + (percent / 100) * 255)));
  return `#${[adj(r), adj(g), adj(b)].map(v => v.toString(16).padStart(2, '0')).join('')}`;
}

const loadedFonts = new Set();
function ensureGoogleFont(family) {
  if (loadedFonts.has(family)) return;
  loadedFonts.add(family);
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = `https://fonts.googleapis.com/css2?family=${encodeURIComponent(family).replace(/%20/g, '+')}:wght@300;400;500;600;700;900&display=swap`;
  document.head.appendChild(link);
}
